export default "__VITE_ASSET__00e31ba3__"